export const generateCSSVariables = (theme) => {
  if (!theme) return;
  const vars = {};
  const EXCLUDED_KEYS = ["id", "assets"];

  const walk = (obj, prefix = "") => {
    Object.entries(obj).forEach(([key, value]) => {
      if (EXCLUDED_KEYS.includes(key)) return;
      const newKey = prefix ? `${prefix}-${key}` : key;

      if (typeof value === "object" && value !== null) {
        walk(value, newKey);
      } else {
        vars[`--${newKey}`] = value;
      }
    });
  };

  walk(theme);
  return vars;
};

export const applyCSSVariables = (vars) => {
  const root = document.documentElement;

  Object.entries(vars).forEach(([key, value]) => {
    root.style.setProperty(key, value);
  });
};
